<script setup lang="ts">
import type { TriangleVariants } from '.';
import type { PrimitiveProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { useMotion } from '@vueuse/motion';
import { Primitive } from 'reka-ui';
import { ref } from 'vue';

import { triangleVariants } from '.';

interface Props extends PrimitiveProps {
	stroke?: TriangleVariants['stroke'];
	class?: HTMLAttributes['class'];
	isStrokeApplied?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	as: 'svg',
	class: '',
	stroke: 'black',
	isStrokeApplied: false
});

const pathRef = ref<HTMLElement>();

const initialStrokeDashoffset = computed(() =>
	props.isStrokeApplied ? 0 : 100
);

const { apply: applyAnimation } = useMotion(pathRef, {
	initial: {
		strokeDashoffset: initialStrokeDashoffset.value
	},
	strokeFormation: {
		strokeDashoffset: 0,
		transition: {
			duration: 2000,
			ease: [0.35, 0.17, 0.3, 0.86]
		}
	}
});

defineExpose({
	pathRef,
	applyAnimation
});
</script>

<template>
	<Primitive
		:as="as"
		:as-child="asChild"
		:class="cn(triangleVariants({ stroke }), props.class)"
		viewBox="0 0 26 28"
	>
		<path
			ref="pathRef"
			:class="{ '[stroke-dashoffset:0]': isStrokeApplied }"
			class="fill-current"
			d="M22.7026 28L0 14.9304L25.9339 0L22.7026 28Z"
		/>
	</Primitive>
</template>
